import {ctPostWithQs} from "./index";

// 외부 DB 저장 요청
export const fetchExternalStore = param => ctPostWithQs("/v1/api/common/external/request/tracing", null, param);